import { STANDING_LABEL, STANDINGS, type Standing } from '@aurora/core'

/**
 * Where cards stand, as one bar: mastered at the left, what she has not met
 * yet fading out at the right. It reads as how far along a deck is, which is
 * the only thing a glance needs.
 */
export function StandingBar({ standings, total }: { standings: Record<Standing, number>; total: number }) {
  const order = [...STANDINGS].reverse()
  return (
    <span className="standing-bar" aria-hidden="true">
      {order.map((s) =>
        standings[s] ? (
          <span key={s} className={`standing-bar-part is-${s}`} style={{ flexGrow: standings[s] / Math.max(1, total) }} />
        ) : null,
      )}
    </span>
  )
}

export function StandingPill({ standing }: { standing: Standing }) {
  return <span className={`standing-pill is-${standing}`}>{STANDING_LABEL[standing]}</span>
}

/** The key to the colours, with how many items sit at each. */
export function StandingLegend({ counts }: { counts?: Partial<Record<Standing, number>> }) {
  return (
    <ul className="standing-legend">
      {[...STANDINGS].reverse().map((s) => (
        <li key={s}>
          <span className={`standing-swatch is-${s}`} aria-hidden="true" />
          {STANDING_LABEL[s]}
          {counts && counts[s] !== undefined && <span className="standing-legend-n tnum">{counts[s]}</span>}
        </li>
      ))}
    </ul>
  )
}
